// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Yv5u2","body":"styles_body__gMNLT","blueline":"styles_blueline__AJQft","noRecords":"styles_noRecords__S16Vc"};